import { useState } from 'react';

export default function Chatbot() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');

  const sendMessage = async () => {
    const userMessage = { role: 'user', text: input };

    setMessages((prev) => [...prev, userMessage]);

    const response = await fetch('/api/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ message: input }),
    });

    const data = await response.json();

    const aiMessage = {
      role: 'ai',
      text: data.reply,
    };

    setMessages((prev) => [...prev, aiMessage]);

    setInput('');
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: '300px',
        background: 'white',
        padding: '15px',
        borderRadius: '10px',
        boxShadow: '0 0 10px rgba(0,0,0,0.2)',
      }}
    >
      <div style={{ height: '200px', overflowY: 'auto' }}>
        {messages.map((msg, i) => (
          <p
            key={i}
            style={{
              textAlign: msg.role === 'user' ? 'right' : 'left',
            }}
          >
            {msg.text}
          </p>
        ))}
      </div>

      <input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        style={{ width: '100%', marginTop: '10px' }}
      />

      <button onClick={sendMessage} style={{ width: '100%', marginTop: '5px' }}>
        Send
      </button>
    </div>
  );
}
